import { TemplateMail } from "domain/entities/template-mail";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface TemplateMailState {
  templateMail: TemplateMail | null;
  setTemplateMail: (newTemplateMail: Partial<TemplateMail>) => void;
  resetTemplateMail: () => void;
}

const initialTemplateMailState: TemplateMail = {
  id: "",
  name: "",
  object: "",
  subject: "",
  content: "",
  createdAt: new Date(),
  modifiedAt: null,
  lastModifiedBy: "",
};

export const useTemplateMailStore = create<TemplateMailState>()(
  devtools(
    (set) => ({
      templateMail: initialTemplateMailState,
      setTemplateMail: (newTemplateMail) =>
        set((state) => ({
          templateMail: {
            ...state.templateMail,
            ...newTemplateMail,
          } as TemplateMail,
        })),
      resetTemplateMail: () => set({ templateMail: initialTemplateMailState }),
    }),
    { name: "TemplateMailSelected" }
  )
);
